import { Fragment, useState } from "react";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Confirm } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import useNotify from "../../unit/useNotify";
import CustomDialogTitle from "../../unit/CustomDialogTitle";

const DocDeleteIcon = ({ ...props }) => {
  const { docId } = props;
  const reqUrl = "files/removeBBUpload/" + docId + "";
  const { success, error } = useNotify();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handDelete = async (docId: number, reqUrl: string) => {
    //用sendRequest完善删除功能，调用接口删除文件后，刷新页面
    try {
      await sendRequest(reqUrl, { id: docId }, "create");
      success("File removed successfully");
      setConfirmOpen(false);
      props?.cb();
    } catch (e) {
      setConfirmOpen(false);
      error("Failed to remove file");
    }
  };

  return (
    <Fragment>
      <IconButton
        edge="end"
        aria-label=""
        sx={{ color: "#1976d2" }}
        onClick={() => setConfirmOpen(true)}
      >
        {/* {docId}- */}
        <DeleteIcon color="error" fontSize="small" sx={{ fontSize: "24px" }} />
      </IconButton>
      <Confirm
        isOpen={confirmOpen}
        title={<CustomDialogTitle title="Delete File" />}
        content="This file will be removed and cannot be recovered. Do you want to continue?"
        confirm="Delete"
        cancel="Cancel"
        confirmColor="primary"
        ConfirmIcon={undefined}
        CancelIcon={undefined}
        onConfirm={() => handDelete(docId, reqUrl)}
        onClose={() => setConfirmOpen(false)}
        maxWidth="xs"
        sx={{
          "& .MuiButton-root.RaConfirm-confirmPrimary": {
            width: "auto",
            backgroundColor: "#d32f2f",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#b71c1c",
            },
          },
          "& .MuiButton-root": {
            minWidth: 120,
            color: "#1976d2",
            bgcolor: "#e0e0e0",
            "&:hover": {
              bgcolor: "#f5f5f5",
            },
          },
          "& .MuiDialogTitle-root": {
            borderBottom: "1px solid #e5e5e5",
          },
          "& .MuiDialogContentText-root": {
            color: "black",
            fontSize: "0.875rem",
            fontFamily: "Proxima Nova",
            mt: "10px",
          },
          "& .MuiDialogActions-root": {
            padding: 2,
            paddingTop: 0,
            justifyContent: "space-between",
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
              display: "none",
            },
          },
        }}
      />
    </Fragment>
  );
};

export default DocDeleteIcon;
